
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
  padding-top:0.5rem;
  padding-bottom:0.5rem;
}

.tab-nav {
  width:100%;
}

@media (min-width: 640px) {

  .tab-nav {
    width:auto;
  }
}

.tab-nav {
  cursor:pointer;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  font-weight:var(--fw-semibold);
  color:var(--primary-blue);
}

.tab-nav:hover {
  color:var(--primary-blue-light-1);
}

.tab-nav {
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
}

@media (min-width: 640px){
  :host {
    padding-top:0px;
    padding-bottom:0px;
  }

  .tab-nav:not(.tab-nav--plain) {
    border-radius:0.75rem;
  }

  .tab-nav:not(.tab-nav--plain) {
    border-width:1px;
  }

  .tab-nav:not(.tab-nav--plain) {
    border-style:solid;
  }

  .tab-nav:not(.tab-nav--plain) {
    text-align:center;
  }

  .tab-nav:not(.tab-nav--plain) {
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }

  .tab-nav:not(.tab-nav--plain) {
    line-height:1;
  }

  .tab-nav:not(.tab-nav--plain) {
    display:flex;
  }

  .tab-nav:not(.tab-nav--plain) {
    align-items:center;
  }

  .tab-nav:not(.tab-nav--plain) {
    justify-content:center;
  }

  .tab-nav:not(.tab-nav--plain) {
    padding:0.75rem;
  }

    .tab-nav:not(.tab-nav--plain).inactive:hover, .tab-nav:not(.tab-nav--plain).active {
    border-color:var(--primary-blue);
  }

    .tab-nav:not(.tab-nav--plain).inactive:hover, .tab-nav:not(.tab-nav--plain).active {
    background-color:var(--primary-blue);
  }

    .tab-nav:not(.tab-nav--plain).inactive:hover, .tab-nav:not(.tab-nav--plain).active {
    color:var(--neutral-white);
  }

    .tab-nav:not(.tab-nav--plain).inactive {
    border-color:var(--primary-blue);
  }

    .tab-nav:not(.tab-nav--plain).inactive {
    background-color:var(--neutral-white);
  }

    .tab-nav:not(.tab-nav--plain).inactive {
    color:var(--primary-blue);
  }
}

@media (min-width: 768px){
  .tab-nav:not(.tab-nav--plain) {
    font-size:var(--fs-base);
    line-height:var(--lh-base);
  }
}

@media (min-width: 640px){
  .tab-nav.tab-nav--plain {
    padding-top:1.5rem;
    padding-bottom:1.5rem;
  }
  .tab-nav.tab-nav--plain {
    padding-left:1rem;
    padding-right:1rem;
  }
  .tab-nav.tab-nav--plain {
    font-family:var(--ff-display);
  }
  .tab-nav.tab-nav--plain {
    border-width:0px;
  }
  .tab-nav.tab-nav--plain {
    border-bottom-width:4px;
  }
  .tab-nav.tab-nav--plain {
    border-style:solid;
  }
  .tab-nav.tab-nav--plain {
    border-color:var(--neutral-white);
  }

    .tab-nav.tab-nav--plain.active {
    border-color:var(--primary-blue-light-3);
  }

    .tab-nav.tab-nav--plain.active {
    background-color:var(--tint-light-blue);
  }

    .tab-nav.tab-nav--plain.active:hover, .tab-nav.tab-nav--plain:hover {
    border-color:var(--primary-blue);
  }

    .tab-nav.tab-nav--plain.active:hover, .tab-nav.tab-nav--plain:hover {
    background-color:var(--primary-blue-light-2);
  }

    .tab-nav.tab-nav--plain.active:hover, .tab-nav.tab-nav--plain:hover {
    color:var(--neutral-white);
  }
}

:host([site='BH']) {
  padding:0px;
}

:host([site='BH']) .tab-nav {
  margin:0px;
}

:host([site='BH']) .tab-nav {
  border-top-left-radius:0.75rem;
  border-top-right-radius:0.75rem;
}

:host([site='BH']) .tab-nav {
  border-bottom-right-radius:0px;
  border-bottom-left-radius:0px;
}

:host([site='BH']) .tab-nav {
  border-style:solid;
}

:host([site='BH']) .tab-nav {
  border-color:var(--bh-brand-primary-default);
}

:host([site='BH']) .tab-nav {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) .tab-nav {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

:host([site='BH']) .tab-nav {
  font-weight:var(--fw-normal);
}

:host([site='BH']) .tab-nav {
  color:var(--bh-brand-primary-darker);
}

@media (min-width: 1024px) {

  :host([site='BH']) .tab-nav {
    margin-bottom:-1px;
  }
}

@media (min-width: 640px) {

  :host([site='BH']) .tab-nav {
    font-size:22px;
  }
}

:host([site='BH']) .tab-nav.is-mobile {
  border-top-left-radius:0px;
  border-top-right-radius:0px;
}

:host([site='BH']) .tab-nav.is-mobile {
  border-width:0px;
}

:host([site='BH']) .tab-nav.is-mobile {
  background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .tab-nav.is-mobile {
  padding:0.75rem;
}

:host([site='BH']) .tab-nav.is-mobile {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .tab-nav.inactive:hover, :host([site='BH']) .tab-nav.active {
  background-color:var(--bh-brand-primary-default);
}

:host([site='BH']) .tab-nav.inactive:hover, :host([site='BH']) .tab-nav.active {
  color:var(--neutral-white);
}

:host([site='BH']) .tab-nav.inactive {
  border-color:var(--bh-neutral-default);
}

:host([site='BH']) .tab-nav:focus {
  outline-width:2px;
}

:host([site='BH']) .tab-nav:focus {
  outline-offset:2px;
}

:host([site='BH']) .tab-nav:focus{
    outline:solid var(--bh-brand-primary-default);
  }
`;